import { render, staticRenderFns } from "./PageManualQR.vue?vue&type=template&id=72e058a0&scoped=true"
import script from "./PageManualQR.vue?vue&type=script&lang=js"
export * from "./PageManualQR.vue?vue&type=script&lang=js"
import style0 from "./PageManualQR.vue?vue&type=style&index=0&id=72e058a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e058a0",
  null
  
)

export default component.exports